import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { Soubi } from './../../models/plan/soubi.model';
import { PlanService } from './../../services/plan.service';

@Component({
  selector: 'app-equipment-modal',
  templateUrl: './equipment-modal.component.html',
  styleUrls: ['./equipment-modal.component.css']
})
export class EquipmentModalComponent implements OnInit {
  public overSelect = true;
  public equipments: any[] = [];
  @Output('close') close: any = new EventEmitter<any>();
  @Output() onequipmentsData: any = new EventEmitter<any>();
  @Input() data: any;
  soubi: Soubi[];
  chkStatus: boolean[] = [];

  constructor(private planService: PlanService) { }

  ngOnInit() {
    if (this.planService.soubiData) {
      this.equipments = [...this.planService.soubiData];
    }

    this.planService.getSoubiData().subscribe(res => {
      if (res) {
        this.soubi = res.map((data: any) => {
          return { ...data, stat: false };
        });
      }
    });
  }

  onClose() {
    this.close.emit();
  }

  onCloseAlt() {
    this.overSelect = true;
  }

  selectedSoubi(sb: any, i: any) {
    this.soubi[i].stat = true;
    const index = this.equipments.findIndex(data => data === sb);
    if (index >= 0) {
      this.equipments.splice(index, 1);
    } else {
      if (this.equipments.length > 11) {
        this.overSelect = false;
        const input = <HTMLInputElement>(document.getElementById('chk-eq-' + this.soubi[i].kbn));
        if (input) {
          input.checked = false;
        }
      } else {
        this.equipments.push(sb);
        this.soubi[i].stat = true;
      }
    }

    // console.log(!this.equipments)
    // console.log( this.soubi[i].stat)
  }

  sendSoubi() {
    this.planService.getSoubi(this.equipments);
    this.onequipmentsData.emit(this.equipments);
    this.close.emit();
  }

  clearSelected() {
    this.equipments = [];
    this.soubi = this.soubi.map((data: any) => {
      return { ...data, stat: false };
    });
  }

  isCheck(kbn) {
    return this.equipments.indexOf(kbn) > -1;
  }
}



// WEBPACK FOOTER //
// ./src/app/plan/equipment-modal/equipment-modal.component.ts